<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2p" id="part01"><a id="page_5"></a><span class="small">PART 1</span><br/><br/>A New Metapsychology of the Unconscious</h2>
<p class="imagel"><img alt="Images" height="1" src="images/line.jpg" width="256"/><a id="page_6"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part01.vue?2c8d6718